import {BaseStage} from "./BaseStage";
import {loading} from "../../../helpers/loading";

class ShowSelectStage extends BaseStage {


    constructor(globalState) {
        super(globalState);

        this.domContainer = document.querySelector(`.stage.${this.getStageKey()}`)

        // Setup show select cards
        this.domContainer.querySelectorAll('.show').forEach(showContainer => {
            const showInput = showContainer.querySelector(`input`);

            showInput.addEventListener('change', () => {
                this.handleShowSelect(showContainer);
            })

            // Trigger show selection
            showContainer.addEventListener('click', () => {
                showInput.checked = true;
                showInput.dispatchEvent(new InputEvent('change'));
            })
        })

        // Run base class initializations
        this.initSharedComponents();
    }

    /**
     * @return {PublicTicketsFormDefs.Stage}
     */
    getStageKey() {
        // noinspection JSValidateTypes
        return 'show-select';
    }

    /**
     * @param {HTMLElement} showContainer
     */
    handleShowSelect(showContainer) {
        /** @var {HTMLInputElement} */
        const showInput = showContainer.querySelector(`input`);

        // Clear all other shows from selection
        this.domContainer.querySelectorAll('.show').forEach(show => {
            show.classList.remove('selected');
            show.querySelector('input').checked = false;
        })

        // Mark show as selected
        showInput.checked = true;
        // And add selected class
        showContainer.classList.add('selected');

        // Store selected event
        const selectedEvent = JSON.parse(showInput.dataset.event);

        this.globalState.setParentEvent(selectedEvent);

        if (!this.shouldAutoSkipDeterministicSelection()) {
            this.enableNextStageButton();
            return;
        }

        const deterministicSelection = this.getDeterministicSelectionFromEvent(selectedEvent);

        if (deterministicSelection) {
            this.globalState.setEventDate(deterministicSelection.date);

            if (deterministicSelection.seatType) {
                // noinspection JSCheckFunctionSignatures
                this.globalState.setSeatType(deterministicSelection.seatType);
            }
        }

        if (deterministicSelection?.canSkipDateSelect) {
            loading();

            const targetStage = deterministicSelection.seatType === 'reserved'
                ? 'seat-select'
                : 'seat-type-select';

            this.globalState.stageManager.goToStage(targetStage);

            return;
        }

        this.enableNextStageButton();
    }

    shouldAutoSkipDeterministicSelection() {
        return true;
    }

    getDeterministicSelectionFromEvent(event) {
        const pendingDates = Array.isArray(event?.pendingDates)
            ? event.pendingDates
            : [];

        if (pendingDates.length !== 1) {
            return null;
        }

        const allDates = Array.isArray(event?.allDates)
            ? event.allDates
            : [];

        const selectedDate = pendingDates[0];
        const seatType = this.getDeterministicSeatTypeFromDate(selectedDate);
        const canSkipDateSelect = event?.dateSelectionType !== 'multiple_dates' || allDates.length === 1;

        if (!selectedDate) {
            return null;
        }

        return {
            date: selectedDate,
            seatType,
            canSkipDateSelect: canSkipDateSelect && !!seatType,
        };
    }

    getDeterministicSeatTypeFromDate(eventDate) {
        const hasGeneralAdmission = eventDate?.hasGeneralAdmissionTicketTypesAvailable === true;
        const hasReserved = eventDate?.hasReservedTicketTypesAvailable === true;

        if (hasGeneralAdmission === hasReserved) {
            return null;
        }

        return hasReserved
            ? 'reserved'
            : 'general-admission';
    }
}

export {ShowSelectStage};
